export const CLIENT_PORTAL_REDIRECT_URL_VARIABLES = [
  '{caseId}',
  '{externalId}',
] as const;
